import type { MutableRefObject } from 'react';
import { useEffect, useRef } from 'react';

/**
 * Remembers and returns the value from the previous invocation. Useful to replicate
 * `componentDidUpdate` in a function component.
 */

type UsePreviousReturnType<T, InitiallyNull extends boolean> = InitiallyNull extends true
  ? T | null
  : T;

export const usePrevious = <T, InitiallyNull extends boolean = false>(
  value: T,
  initiallyNull: InitiallyNull = false as InitiallyNull
): UsePreviousReturnType<T, InitiallyNull> => {
  const ref = useRef<UsePreviousReturnType<T, InitiallyNull>>(
    initiallyNull ? null : value
  ) as MutableRefObject<UsePreviousReturnType<T, InitiallyNull>>;

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};
